<template>
    <div class="notify">
        <div class="notify-wrapper">
            <h3 class="notify-text">{{ $t('noticePayments') }}</h3>
        </div>
    </div>
</template>

<style>
.notify {
    padding: 20px;
    margin-top: 20px;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    gap: 15px;
    background-color: var(--gray);
    border-radius: var(--card-br);
}

@media screen and (max-width: 500px) {
    .notify {
        align-items: center;
    }
}

.notify-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 5px;
    justify-content: center;
}

.notify-text {
    color: var(--red);
    margin-bottom: 3px;
    font-weight: 500;
}
</style>